import React from "react";
import "./css/Habitaciones.css";
import imagen1 from "../img/img-hotel/hotel-imagenes (24).jpg";
import imagen2 from "../img/img-hotel/hotel-imagenes (19).jpg";
import imagen3 from "../img/img-hotel/hotel-imagenes (14).jpg";
import imagen4 from "../img/img-hotel/hotel-imagenes (13).jpg";
import imagen5 from "../img/img-hotel/hotel-imagenes (12).jpg";
import imagen6 from "../img/img-hotel/hotel-imagenes (9).jpg";
import imagen7 from "../img/img-hotel/hotel-imagenes (7).jpg";
import imagen8 from "../img/img-hotel/hotel-imagenes (15).jpg";

function Habitaciones() {
  return (
    <section id="rooms">
      <div className="title-habitaciones">
        <h2>Habitaciones</h2>
      </div>
      <div className="container-cards">
        <div className="card">
          <div
            id="carouselExampleControlsNoTouching1"
            className="carousel slide"
            data-bs-touch="false"
          >
            <div className="carousel-inner">
              <div className="carousel-item active">
                <img src={imagen1} className="d-block w-100" alt="..." />
              </div>
              <div className="carousel-item">
                <img src={imagen2} className="d-block w-100" alt="..." />
              </div>
              <div className="carousel-item">
                <img src={imagen3} className="d-block w-100" alt="..." />
              </div>
              <div className="carousel-item">
                <img src={imagen4} className="d-block w-100" alt="..." />
              </div>
              <div className="carousel-item">
                <img src={imagen5} className="d-block w-100" alt="..." />
              </div>
              <div className="carousel-item">
                <img src={imagen6} className="d-block w-100" alt="..." />
              </div>
              <div className="carousel-item">
                <img src={imagen7} className="d-block w-100" alt="..." />
              </div>
              <div className="carousel-item">
                <img src={imagen8} className="d-block w-100" alt="..." />
              </div>
            </div>
            <button
              className="carousel-control-prev"
              type="button"
              data-bs-target="#carouselExampleControlsNoTouching1"
              data-bs-slide="prev"
            >
              <span
                className="carousel-control-prev-icon"
                aria-hidden="true"
              ></span>
              <span className="visually-hidden">Previous</span>
            </button>
            <button
              className="carousel-control-next"
              type="button"
              data-bs-target="#carouselExampleControlsNoTouching1"
              data-bs-slide="next"
            >
              <span
                className="carousel-control-next-icon"
                aria-hidden="true"
              ></span>
              <span className="visually-hidden">Next</span>
            </button>
          </div>
          <div className="card-body">
            <h5 className="card-title">Standard</h5>
            <p className="card-text text-muted">
              Cálida y funcional para 1-2 huéspedes. Baño privado, TV y WiFi.
            </p>
            <a href="#booking" className="btn btn-primary">
              Reservar
            </a>
          </div>
        </div>
        <div className="card">
          <div
            id="carouselExampleControlsNoTouching2"
            className="carousel slide"
            data-bs-touch="false"
          >
            <div className="carousel-inner">
              <div className="carousel-item active">
                <img src={imagen1} className="d-block w-100" alt="..." />
              </div>
              <div className="carousel-item">
                <img src={imagen2} className="d-block w-100" alt="..." />
              </div>
              <div className="carousel-item">
                <img src={imagen3} className="d-block w-100" alt="..." />
              </div>
              <div className="carousel-item">
                <img src={imagen4} className="d-block w-100" alt="..." />
              </div>
              <div className="carousel-item">
                <img src={imagen5} className="d-block w-100" alt="..." />
              </div>
              <div className="carousel-item">
                <img src={imagen6} className="d-block w-100" alt="..." />
              </div>
              <div className="carousel-item">
                <img src={imagen7} className="d-block w-100" alt="..." />
              </div>
              <div className="carousel-item">
                <img src={imagen8} className="d-block w-100" alt="..." />
              </div>
            </div>
            <button
              className="carousel-control-prev"
              type="button"
              data-bs-target="#carouselExampleControlsNoTouching2"
              data-bs-slide="prev"
            >
              <span
                className="carousel-control-prev-icon"
                aria-hidden="true"
              ></span>
              <span className="visually-hidden">Previous</span>
            </button>
            <button
              className="carousel-control-next"
              type="button"
              data-bs-target="#carouselExampleControlsNoTouching2"
              data-bs-slide="next"
            >
              <span
                className="carousel-control-next-icon"
                aria-hidden="true"
              ></span>
              <span className="visually-hidden">Next</span>
            </button>
          </div>
          <div className="card-body">
            <h5 className="card-title">Superior</h5>
            <p className="card-text text-muted">
              Más espacio y confort. Sommier queen, frigobar y escritorio.
            </p>
            <a href="#booking" className="btn btn-primary">
              Reservar
            </a>
          </div>
        </div>
        <div className="card">
          <div
            id="carouselExampleControlsNoTouching3"
            className="carousel slide"
            data-bs-touch="false"
          >
            <div className="carousel-inner">
              <div className="carousel-item active">
                <img src={imagen1} className="d-block w-100" alt="..." />
              </div>
              <div className="carousel-item">
                <img src={imagen2} className="d-block w-100" alt="..." />
              </div>
              <div className="carousel-item">
                <img src={imagen3} className="d-block w-100" alt="..." />
              </div>
              <div className="carousel-item">
                <img src={imagen4} className="d-block w-100" alt="..." />
              </div>
              <div className="carousel-item">
                <img src={imagen5} className="d-block w-100" alt="..." />
              </div>
              <div className="carousel-item">
                <img src={imagen6} className="d-block w-100" alt="..." />
              </div>
              <div className="carousel-item">
                <img src={imagen7} className="d-block w-100" alt="..." />
              </div>
              <div className="carousel-item">
                <img src={imagen8} className="d-block w-100" alt="..." />
              </div>
            </div>
            <button
              className="carousel-control-prev"
              type="button"
              data-bs-target="#carouselExampleControlsNoTouching3"
              data-bs-slide="prev"
            >
              <span
                className="carousel-control-prev-icon"
                aria-hidden="true"
              ></span>
              <span className="visually-hidden">Previous</span>
            </button>
            <button
              className="carousel-control-next"
              type="button"
              data-bs-target="#carouselExampleControlsNoTouching3"
              data-bs-slide="next"
            >
              <span
                className="carousel-control-next-icon"
                aria-hidden="true"
              ></span>
              <span className="visually-hidden">Next</span>
            </button>
          </div>
          <div className="card-body">
            <h5 className="card-title">Suite</h5>
            <p className="card-text text-muted">
              Ambiente premium con living, vista destacada y amenities
              exclusivos.
            </p>
            <a href="#booking" className="btn btn-primary">
              Reservar
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Habitaciones;
